import { Component, OnInit, Injector, HostBinding } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'nemeric-stepper',
	template: `
		<label for="{{ control.name }}" *ngIf="control.subtitle" class="title">{{ control.subtitle }}</label>

		<div
			class="numeric-stepper-container"
			[ngClass]="{ disabled: control.disabled, filled: !(+value <= control.attributes.minValue) }"
		>
			<div class="icon-container">
				<span
					class="button-container"
					[tabindex]="control.disabled || +value <= control.attributes.minValue ? -1 : 0"
					(keypress)="$event.key == 'Enter' ? decrement() : false"
				>
					<button
						class="minus-button"
						tabindex="-1"
						gtm-handler
						[attr.gtm]="control.name"
						events="click"
						handlerType="radio"
						[label]="control.name"
						[value]="value?.toString()"
						action="RadioButton"
						[ngClass]="{ 'min-value': +value <= control.attributes.minValue }"
						[disabled]="control.disabled"
						(click)="decrement()"
						[attr.aria-label]="'Press to decrement the' + ' ' + control.title"
					>
						<i class="icon icon-minus"></i>
					</button>
				</span>
			</div>

			<input
				type="number"
				[attr.id]="control.name.split('PolicyData.').join('')"
				[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
				[(ngModel)]="value"
				class="number-stepper"
				autocomplete="off"
				readonly="true"
				aria-live="polite"
				disabled
			/>

			<div class="icon-container">
				<span
					class="button-container"
					[tabindex]="control.disabled ? -1 : 0"
					(keypress)="$event.key == 'Enter' ? increment() : false"
				>
					<button
						class="plus-button"
						tabindex="-1"
						[attr.gtm]="control.name"
						gtm-handler
						events="click"
						handlerType="radio"
						[label]="control.name"
						action="RadioButton"
						[value]="value?.toString()"
						[disabled]="control.disabled"
						(click)="increment()"
						[attr.aria-label]="'Press to increment the' + ' ' + control.title"
					>
						<i class="icon icon-plus"></i>
					</button>
				</span>
			</div>
		</div>
	`,
	styleUrls: ['./numeric-stepper.component.scss'],
})
export class NumericStepperComponent extends EventsComponent implements OnInit {
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	subtitle: string;

	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = this.control.name;
		if (this.value) {
			if (this.value > this.control.attributes.maxValue) {
				this.value = this.control.attributes.maxValue;
				this.setAnswer(this.value);
			}
			this.reportPrefill();
		}
	}

	increment() {
		if (this.value < this.control.attributes.maxValue) {
			var newVal = parseInt(this.value) + parseInt(this.control.attributes.increments);
			this.setAnswer(newVal);
			this.value++;
			this.reportEditedPrefillValue();
		}
	}

	decrement() {
		if (this.value > this.control.attributes.minValue) {
			var newVal = parseInt(this.value) - parseInt(this.control.attributes.increments);
			this.setAnswer(newVal);
			this.value--;
			this.reportEditedPrefillValue();
		}
	}

	skipFocus(e) {
		if (e.relatedTarget && e.relatedTarget.className == 'minus-button') {
			this.elementRef.nativeElement.querySelectorAll('button')[1].focus();
		} else {
			this.elementRef.nativeElement.querySelectorAll('button')[0].focus();
		}
	}

	onKeydown(event) {
		// prevent not valid values also on arrows press
		const kc = event.which || event.keyCode;
		const unAllowedChars: number[] = [189, 187, 109, 107, 69, 101];
		if (unAllowedChars.includes(kc)) {
			return false;
		}
		if (kc === 38) {
			if (this.value) {
				if (this.value + 1 > this.control.attributes.maxValue) {
					event.preventDefault();
				}
			}
		}
		if (kc === 40) {
			if (this.value) {
				if (this.value - 1 < this.control.attributes.minValue) {
					event.preventDefault();
				}
			}
		}
	}

	preventAction(e: Event) {
		e.preventDefault();
	}
}
